// extracted by mini-css-extract-plugin
export default {"link":"_0ZVhA","timeAgo":"+uGuC","avatar":"_0tzlO","directionIcon":"hslru","text":"P--SB"};